// extracted by mini-css-extract-plugin
export var fadeOut = "videoReviews-module--fadeOut--6495f";
export var mySwiper = "videoReviews-module--mySwiper--b9d7d";
export var opacity100 = "videoReviews-module--opacity-100--23f8f";
export var swiperButtonDisabled = "videoReviews-module--swiper-button-disabled--0d754";
export var swiperButtonNext = "videoReviews-module--swiper-button-next--316da";
export var swiperButtonPrev = "videoReviews-module--swiper-button-prev--26192";
export var swiperPagination = "videoReviews-module--swiper-pagination--75aa2";
export var videoReviews = "videoReviews-module--video-reviews--3346a";
export var videoReviews__img = "videoReviews-module--video-reviews__img--b9350";
export var videoReviews__info = "videoReviews-module--video-reviews__info--17a38";
export var videoReviews__play = "videoReviews-module--video-reviews__play--70be4";
export var videoReviews__videoBlock = "videoReviews-module--video-reviews__video-block--ee997";
export var videoReviews__videoFrame = "videoReviews-module--video-reviews__video-frame--21ea4";
export var videoReviews__videoWrapper = "videoReviews-module--video-reviews__video-wrapper--ba499";
export var videoReviews__wrapper = "videoReviews-module--video-reviews__wrapper--6b708";